import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(_theme => ({
  notification: {
    width: '100%',
    margin: 0,
  },
}))

